import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=5bb46918&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=5bb46918&prod&scoped=true&lang=css"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=5bb46918&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb46918",
  null
  
)

export default component.exports